import * as fs from 'fs';
import BUILDER_FUNCTIONS from '../assets/builder_functions.json';

export type BuilderConfig = {
    name: string,
    input: {
        name: string,
        type: 'number' | 'number[]' | 'string'
    }[],
    output: {
        type: string
    }
}

export class InterfaceBuilder {
    constructor() { }

    buildInterface(conf: BuilderConfig): void {
        const filePath = `src/ciao-interfaces/${conf.name}.ts`;

        // Create directory to hold interfaces
        this.createDirectory();

        // Import CiaoPrologInterface
        fs.writeFileSync(filePath, `${BUILDER_FUNCTIONS["PLAIN-TEXT"]["IMPORT-CP"]}\n\n`);

        // Function declaration 
        fs.appendFileSync(filePath, `${this.formatHeader(conf)}\n`);

        // Input conversion from TypeScript to Ciao
        fs.appendFileSync(filePath, `${this.formatInputs(conf.input)}\n`);

        // Build query
        fs.appendFileSync(filePath, `${this.formatQuery(conf)}\n`);

        // Call Ciao
        fs.appendFileSync(filePath, `\t${BUILDER_FUNCTIONS["PLAIN-TEXT"]["CIAO-CALL"]}\n\n`);

        // Output conversion from Ciao to TypeScript
        fs.appendFileSync(filePath, `${this.formatOutput(conf.output)}\n`);

        // Return result
        fs.appendFileSync(filePath, `\treturn res_ts;\n}`);
    }

    private createDirectory() {
        var dir = './src/ciao-interfaces';

        if (!fs.existsSync(dir)) {
            fs.mkdirSync(dir);
        }
    }

    private formatHeader(conf: BuilderConfig): string {
        let header = `export async function ${conf.name}(cp: CiaoPrologInterface`;
        conf.input.forEach((param) => header = header.concat(`, ${param.name}: ${param.type}`));
        header = header.concat(`): Promise<${conf.output.type}> {\n`);
        return header;
    }

    private formatInputs(input: BuilderConfig['input']): string {
        let inputs = `\t// Converting from TS to Prolog\n`;

        input.forEach(param => {
            inputs = inputs.concat(`\tconst ${param.name}_cp = cp.${BUILDER_FUNCTIONS["CIAO-TO-TS"][param.type]}(${param.name});\n`);
        });
        inputs = inputs.concat(`\tconst varName_cp = cp.ciao_mk_string('Res');\n`);

        return inputs;
    }

    private formatQuery(conf: BuilderConfig): string {
        const input = [...conf.input, { name: 'varName' }];

        let query = `\t// Building query
        const query = {
            name: '${conf.name}',
            args: [${input.map(param => param.name + '_cp').toString()}]
        };\n`;

        return query;
    }

    private formatOutput(output: BuilderConfig['output']): string {
        let outputs =
            `\t// Converting from Prolog to TS \n \t${BUILDER_FUNCTIONS["PLAIN-TEXT"]["CIAO-GET-RESPONSE"]}\n`;

        switch (output.type) {
            case 'number[]':
                outputs = outputs.concat(`\tconst res_ts = cp.ciao_get_list_from_string<number>(res_cp);\n`);
                break;
        }

        return outputs;
    }
}

